<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Generic Modal</h1>
       <h4 class="mt-4">Triggers</h4>
        <ul>
            <li>Page load - add prop visible</li>
            <li>Interval - :interval="5" (5 seconds)</li>
            <li><a href="#" v-b-modal="'PersonalizedQuizModal'"
                    class="text-primary">Open Personalized Quiz Modal</a></li>
            <li><a href="#" v-b-modal="'QuizModal'"
                    class="text-primary">Open Quiz Modal</a></li>
            <li><a href="#" v-b-modal="'GenericModal'"
                    class="text-primary">Open Generic Modal With Component</a></li>
            <li>
                <a href="#" v-on:click="$root.$emit('bv::show::modal', 'PersonalizedQuizModal')"
 class="text-primary">Open Personalized Quiz Modal with Emit</a>
            </li>
            <!-- <li><b-button id="show-btn" v-b-modal.PersonalizedQuizModal>Open Modal</b-button></li> -->
        </ul>

        <!-- A H A  M O D A L -->
        <aha-modal :interval="0" id="GenericModal" ref="GenericModal" class="c-modal--generic"
            title="Quiz" hide-footer centered>
            <!-- C O N T E N T  P L A C E H O L D E R -->
            <article class="c-article-card c-article-card--large h-text-contrast">
                <p class="c-article-card__label">
                    <span class="c-label c-label--green">In The News</span>
                </p>

                <a href="#" class="c-article-card__link">
                    <div href="#"
                        class="c-article-card__background h-placeholder-image h-placeholder-image--4-3">
                        <img src="assets/images/placeholder.gif"
                            v-lazy-img="'//placehold.it/750x563/ddd/ccc?text=FPO'" />
                    </div>

                    <div class="c-article-card__content">
                        <p class="c-article-card__metadata"><time datetime="2017-10-03">Oct. 3,
                                2017</time> / By American Heart Association News</p>

                        <h2 class="c-article-card__title h3">Meditation May Decrease The Risk Of Heart
                            Disease</h2>

                        <p class="c-article-card__subtitle">Live a long and healthy life, The American
                            Heart Association has your back.</p>
                    </div>
                </a>
            </article>
            <!-- E N D -->

        </aha-modal>

        <!-- A H A  M O D A L -->
        <aha-modal :interval="0" id="PersonalizedQuizModal" ref="PersonalizedQuizModal"
            class="c-modal--generic" title="Modal Header" hide-footer centered scrollable>
            <!-- C O N T E N T  P L A C E H O L D E R -->
            <!-- Q U I Z  P E R S O N A L I Z E D -->
            <aha-transition-group class="c-hero-card-snackable" ref="QuizModal">
                <div class="c-hero-card-snackable__container">
                    <div class="c-hero-card-snackable__content" aria-live="polite">
                        <!-- ================= Start Step 1 ================== -->
                        <aha-transition-step class="c-hero-card-snackable__transition" :step-key="1">
                            <h2 class="c-daily-journey__heading h3">Cholesterol high? Let Us Help You
                                Find The Perfect Meal. </h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam mollis
                                elementum felis, a pretium felis. </p>
                            <p class="c-daily-journey__slide-number mt-3">1 of 3</p>
                            <div class="c-daily-journey__actions">
                                <aha-transition-trigger type="button"
                                    class="c-daily-journey__button btn btn-round btn-lg btn-danger">
                                    Next
                                </aha-transition-trigger>
                            </div>
                        </aha-transition-step>
                        <!-- ================= End Step 1 ==================== -->
                        <!-- ================= Start Step 2 ================== -->
                        <aha-transition-step class="c-hero-card-snackable__transition" :step-key="2">
                            <h2 class="c-daily-journey__heading h3">Choose a Protein</h2>
                            <div class="form-group mt-2 mb-0">
                                <fieldset>
                                    <div data-v-546c2c52="">
                                        <div class="c-quiz-personalized__selects">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio1"
                                                    name="customRadioGroup" checked
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio1">Bisquit</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio2"
                                                    name="customRadioGroup"
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio2">Toast</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio3"
                                                    name="customRadioGroup"
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio3">Waffle</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio4"
                                                    name="customRadioGroup" checked
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio4">Turkey</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio5"
                                                    name="customRadioGroup"
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio5">Salmon</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio6"
                                                    name="customRadioGroup"
                                                    class="custom-control-input">
                                                <label class="custom-control-label"
                                                    for="customRadio6">Lean Beef</label>
                                            </div>
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                            <p class="c-daily-journey__slide-number mt-3">2 of 3</p>
                            <div class="c-daily-journey__actions--multiple">
                                <aha-transition-trigger type="button" step-index="1"
                                    class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2"
                                    v-register-event event-item-id="12345" event-text="eventText">
                                    Back
                                </aha-transition-trigger>
                                <aha-transition-trigger type="button"
                                    class="c-daily-journey__button btn btn-round btn-lg btn-danger"
                                    v-register-event event-item-id="123456" event-text="eventText">
                                    Next
                                </aha-transition-trigger>
                            </div>
                        </aha-transition-step>
                        <!-- ================= End Step 2 ==================== -->
                        <!-- ================= Start Step 3 ================== -->
                        <aha-transition-step class="c-hero-card-snackable__transition" :step-key="3">
                            <div class="c-hero-card-snackable-full-quiz__retake pb-4">
                                <aha-transition-trigger type="button" step-index="1"
                                    class="p-0 m-0 bg-white border-0" v-register-event
                                    event-item-id="123456" event-text="eventText">
                                    <img src="assets/glyphs/retake-quiz-Icon.svg" /> Retake Quiz
                                </aha-transition-trigger>
                            </div>

                            <div class="c-daily-journey">
                                <h2 class="c-daily-journey__heading h3">Try This: Salmon With Sauted
                                    Greens And Veggies</h2>

                                <a href="/en" class="btn btn-secondary-link ml-0 pl-0">Get the Recipe
                                    Here!</a>
                                <a href="/en" class="btn btn-secondary-link ml-0 pl-0">Show Me Something
                                    Else!</a>
                                <p class="c-daily-journey__slide-number mt-3">3 of 3</p>
                                <div class="c-daily-journey__share--quiz">
                                    <p class="h3 mr-3">Share:</p>
                                    <a href="http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"
                                        v-share-button>
                                        <img src="/assets/share/facebook.svg" />
                                    </a>

                                    <a href="http://www.twitter.com/intent/tweet?url=http://test.com&text=description"
                                        v-share-button>
                                        <img src="/assets/share/twitter.svg" />
                                    </a>

                                    <a href="mailto:?subject=Big%20News&body=Body-goes-here">
                                        <img src="/assets/share/mail.svg" />
                                    </a>

                                    <a href="#0">
                                        <img src="/assets/share/copy-link.svg" />
                                    </a>
                                </div>
                            </div>
                        </aha-transition-step>
                        <!-- ================= End Step 3 ================== -->
                    </div>


                </div>
            </aha-transition-group>
            <!-- E N D -->
        </aha-modal>

        <!-- A H A  M O D A L -->
        <aha-modal :interval="0" id="QuizModal" ref="QuizModal" class="c-modal--generic"
            title="Modal Header" hide-footer centered scrollable>
            <!-- C O N T E N T  P L A C E H O L D E R -->
            <!-- Q U I Z -->
            <aha-transition-group class="c-hero-card-snackable-full-quiz">
                <aha-transition-group-form :error-step-key=7 url="/aha-service/grfw/Quiz"
                    name="Strip Down">

                    <template slot-scope="formCtrl">

                        <!-- ================= Sitecore START Here ================== -->
                        <div class="c-hero-card-snackable-full-quiz">
                            <div class="" aria-live="polite">

                                <!-- ================= Start Step 1 ================== -->
                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="1">

                                    <h2 class="c-daily-journey__heading h3">Which Breakfast Item Are
                                        You?</h2>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                                        mollis elementum felis, a pretium felis. Maecenas tempor blandit
                                        libero, ut tempor augue posuere non. Donec sed auctor arcu.
                                        Vivamus consectetur eros id mauris egestas semper. Phasellus et
                                        diam ac justo tempus vulputate. </p>
                                    <p class="c-daily-journey__slide-number">1 of 6</p>


                                    <div class="c-daily-journey__actions">
                                        <aha-transition-trigger type="button"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger">
                                            Next
                                        </aha-transition-trigger>
                                    </div>




                                </aha-transition-step>
                                <!-- ================= End Step 1 ==================== -->

                                <!-- ================= Start Step 2 ================== -->
                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="2">

                                    <h2 class="c-daily-journey__heading h3" id="whichBreakfastHeading">
                                        Which One Would You Choose</h2>

                                    <div class="form-group mt-2">

                                        <div class="c-daily-journey__selects">

                                            <fieldset aria-required="true"
                                                aria-labelledby="whichBreakfastHeading">

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="bisquit"
                                                        name="whichBreakfast"
                                                        class="custom-control-input" value="Bisquit"
                                                        v-input.radio="'whichBreakfast'">
                                                    <label class="custom-control-label"
                                                        for="bisquit">Bisquit</label>
                                                </div>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="toast" name="whichBreakfast"
                                                        class="custom-control-input" value="Toast"
                                                        v-input.radio="'whichBreakfast'">
                                                    <label class="custom-control-label"
                                                        for="toast">Toast</label>
                                                </div>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="waffle"
                                                        name="whichBreakfast"
                                                        class="custom-control-input" value="Waffle"
                                                        v-input.radio="'whichBreakfast'">
                                                    <label class="custom-control-label"
                                                        for="waffle">Waffle</label>
                                                </div>

                                            </fieldset>

                                        </div>

                                    </div>

                                    <p class="c-daily-journey__slide-number">2 of 6</p>

                                    <div class="c-daily-journey__actions--multiple">


                                        <aha-transition-trigger step-index="1" type="button"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2">
                                            Back
                                        </aha-transition-trigger>

                                        <button type="button"
                                            class="buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger"
                                            :disabled="!formCtrl.formData.whichBreakfast"
                                            v-on:click="formCtrl.quizSubmitForm">
                                            Next
                                        </button>

                                    </div>

                                </aha-transition-step>

                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="3">

                                    <h2 class="c-daily-journey__heading h3">{{ formCtrl.ResponseTitle }}
                                    </h2>

                                    <p>{{ formCtrl.ResponseText }}</p>
                                    <p class="c-daily-journey__slide-number">3 of 6</p>

                                    <div class="c-daily-journey__actions--multiple">

                                        <aha-transition-trigger step-index="2" type="button"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2">
                                            Back
                                        </aha-transition-trigger>

                                        <button type="button"
                                            class="buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger"
                                            :disabled="!formCtrl.formData.whichBreakfast"
                                            v-on:click="formCtrl.quizSubmitForm">
                                            Next
                                        </button>


                                    </div>

                                </aha-transition-step>
                                <!-- ================= End Step 2 ==================== -->

                                <!-- ================= Start Step 3 ================== -->
                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="4">

                                    <h2 class="c-daily-journey__heading h3" id="healthyDietHeading">The
                                        simplest way to enjoy a healthy diet is with:</h2>

                                    <div class="form-group mt-2">

                                        <div class="c-daily-journey__selects">

                                            <fieldset aria-required="true"
                                                aria-labelledby="healthyDietHeading">

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="candy" name="healthyDiet"
                                                        class="custom-control-input" value="Candy"
                                                        v-input.radio="'healthyDiet'">
                                                    <label class="custom-control-label"
                                                        for="candy">Candy</label>
                                                </div>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="butter" name="healthyDiet"
                                                        class="custom-control-input" value="Butter"
                                                        v-input.radio="'healthyDiet'">
                                                    <label class="custom-control-label"
                                                        for="butter">Butter</label>
                                                </div>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="burger" name="healthyDiet"
                                                        class="custom-control-input" value="Burger"
                                                        v-input.radio="'healthyDiet'">
                                                    <label class="custom-control-label"
                                                        for="burger">Burger</label>
                                                </div>

                                            </fieldset>

                                        </div>

                                    </div>

                                    <p class="c-daily-journey__slide-number">4 of 6</p>

                                    <div class="c-daily-journey__actions--multiple">

                                        <aha-transition-trigger step-index="3" type="button"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2">
                                            Back
                                        </aha-transition-trigger>

                                        <button type="button"
                                            class="buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger"
                                            :disabled="!formCtrl.formData.whichBreakfast"
                                            v-on:click="formCtrl.quizSubmitForm">
                                            Next
                                        </button>

                                    </div>

                                </aha-transition-step>

                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="5">

                                    <h2 class="c-daily-journey__heading h3">{{ formCtrl.ResponseTitle }}
                                    </h2>

                                    <p>{{ formCtrl.ResponseText }}</p>
                                    <p class="c-daily-journey__slide-number">5 of 6</p>

                                    <div class="c-daily-journey__actions--multiple">
                                        <aha-transition-trigger type="button" step-index="4"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2">
                                            Back
                                        </aha-transition-trigger>

                                        <button type="button"
                                            class="buttondisable c-daily-journey__button btn btn-round btn-lg btn-danger"
                                            :disabled="!formCtrl.formData.whichBreakfast"
                                            v-on:click="formCtrl.quizSubmitForm">
                                            Next
                                        </button>
                                    </div>

                                </aha-transition-step>
                                <!-- ================= End Step 3 ==================== -->

                                <!-- ==== FOR BACK-END DEV ====
        
                                    After an ajax response, the response data can be used, but then must referenced in the format of:
                                    {{ formCtrl.response.PropertyName }}
        
                                    If the response has deeper nested properties, then you must wrap the value in a v-if to ensure the property exists before trying to render.
        
                                    e.g. With this response
                                    {
                                        "DeepObject": {
                                            "Item": {
                                                "Test": "Test"
                                            }
                                        }
                                    }
        
                                    You'd need something like this:
        
                                    <div v-if="formCtrl.response.DeepObject">
                                        {{ formCtrl.response.DeepObject.Item.Test }}
                                    </div>
        
                                ====== -->

                                <!-- ================= Start Step 4 ================== -->
                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="6">

                                    <div class="c-hero-card-snackable-full-quiz__retake pb-4">

                                        <button type="button" step-index="1"
                                            class="c-cta btn btn-link h-theme--red"
                                            v-on:click="formCtrl.resetForm">
                                            <img src="assets/glyphs/retake-quiz-Icon.svg"
                                                class="mr-2" /> Retake Quiz
                                        </button>

                                    </div>

                                    <div class="c-daily-journey">

                                        <h2 class="c-daily-journey__heading h3">You Got: Avocado Toast
                                        </h2>

                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                            do eiusmod tempor incididunt ut labore et dolore magna
                                            aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                            ullamco laboris nisi ut.</p>

                                        <a href="#" class="c-cta h-theme--red">Get the Recipe Here!</a>

                                        <p class="c-daily-journey__slide-number mt-3">6 of 6</p>

                                        <div class="c-daily-journey__share--quiz">

                                            <p class="h3 mr-3">Share:</p>

                                            <a href="http://www.facebook.com/sharer/sharer.php?u=http://test.com&t=description"
                                                v-share-button>
                                                <img src="assets/share/facebook.svg" />
                                            </a>

                                            <a href="http://www.twitter.com/intent/tweet?url=http://test.com&text=description"
                                                v-share-button>
                                                <img src="assets/share/twitter.svg" />
                                            </a>

                                            <a href="mailto:?subject=Big%20News&body=Body-goes-here">
                                                <img src="assets/share/mail.svg" />
                                            </a>

                                            <a href="#0">
                                                <img src="assets/share/copy-link.svg" />
                                            </a>

                                        </div>
                                    </div>

                                </aha-transition-step>
                                <!-- ================= End Step 4 ================== -->

                                <!-- ================= Start: Error Message ================== -->
                                <aha-transition-step
                                    class="c-hero-card-snackable-full-width__transition" :step-key="7">
                                    <div class="alert alert-danger" role="alert">
                                        Uh oh, it appears that there was a network issue.
                                    </div>
                                    <div class="c-make-commitment__actions">
                                        <aha-transition-trigger step-index="2" type="button"
                                            class="c-daily-journey__button btn btn-round btn-lg btn-danger mb-2">
                                            Back
                                        </aha-transition-trigger>
                                    </div>
                                </aha-transition-step>
                                <!-- ================= End: Error Message ================== -->

                            </div>
                        </div>
                        <!-- ================= Sitecore END Here ================== -->
                    </template>

                </aha-transition-group-form>

            </aha-transition-group>
            <!-- E N D -->

        </aha-modal>
   



    </div>
</template>

<script>
// import Vue from 'vue';
export default {
    provide() {
            return {
                // EventBus: this.EventBus
            };
        },
    data() {
        return {
            // EventBus: new Vue(),
        }
    },
    mounted() {

        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child
        
        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on('bv::modal::hidden', ($event) => {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);

        })
    }
}
</script>



// WEBPACK FOOTER //
// demo/pages/components/generic-modal.vue